var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-state",style:({ minHeight: `${_vm.height}px` })},[_c('span',{staticClass:"empty-state-title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"empty-state-message"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }